/*# sourceMappingURL=speech-with-action.component-YKHR7W5T.css.map */
